import React from 'react';
import { Form, Formik } from 'formik';
import { customStyle } from '@custom/Utils/utils';
import { getIcon } from '@ohif/ui';

const UrgencyForm = ({ editUrgency, initialValues, submitForm, edit, setEdit, setShowUrgencyForm, isSubmitting }) => {
  const caseOptions = [
    { value: 'Critical', label: 'Critical' },
    { value: 'Priority', label: 'Priority' },
    { value: 'Routine', label: 'Routine' },
  ];

  return (
    <div className="details">
      <div className="form form--innersec">
        <div className="mb-3">
          <button
            className='Btnback'
            onClick={() => setShowUrgencyForm(false)}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {getIcon('icon-toolbar-back')}
            Back
          </button>
        </div>
        <section className="form__section">
          <h1 className="form__section__title">
            {editUrgency ? 'Edit Urgency Charges' : 'Add Urgency Charges'}
          </h1>
          <Formik
            initialValues={initialValues}
            onSubmit={submitForm}
            enableReinitialize={true}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              const isFormValid =
                values.urgencyCase &&
                values.urgencyPrice &&
                Number(values.urgencyPrice) > 0;

              return (
                <Form onSubmit={handleSubmit}>
                  <div className="formRow formRow__2">
                    <div className="formCol mt-1">
                      <div className="form__Field">
                        <label className="form__label" htmlFor="urgencyCase">
                          Case<span className="required-asterisk">*</span>
                        </label>
                        <select
                          id="urgencyCase"
                          name="urgencyCase"
                          className="form__select form__select--sm"
                          onBlur={handleBlur}
                          value={values.urgencyCase}
                          onChange={handleChange}
                          autoComplete="off"
                          style={customStyle.select}
                        >
                          <option value="">-Select Case-</option>
                          {caseOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="formCol">
                      <div className="form__Field">
                        <label className="form__label" htmlFor="urgencyPrice">
                          Price<span className="required-asterisk">*</span>
                        </label>
                        <input
                          type="text"
                          className="form__input form__input--sm mt-1"
                          id="urgencyPrice"
                          name="urgencyPrice"
                          placeholder="Price"
                          value={values.urgencyPrice}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value) || value === '') {
                              setFieldValue("urgencyPrice", value);
                            }
                          }}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {values.urgencyPrice && Number(values.urgencyPrice) <= 0 && (
                          <span style={{ color: 'red', fontSize: '12px' }}>
                            Price must be greater than 0
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="btn__group">
                    <button
                      className="btn btn__primary"
                      type="submit"
                      disabled={!isFormValid || isSubmitting}
                    >
                      {edit ? 'Update' : 'Save'}
                    </button>
                    <button
                      className="btn btn__white"
                      type="button"
                      onClick={() => {
                        setShowUrgencyForm(false);
                        setEdit(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </section>
      </div>
    </div>
  );
};

export default UrgencyForm;
